/*
* Project: LegalPlace assistant
* File: errors/error.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import { store } from '../globals';
import { lpSetError, lpUnsetError } from '../redux/actions/lperrors';
import lpApp from '../app/lp_app';

const lpErrorType = {
  GLOBAL: 0,
  LOCAL: 1,
  REPEATED: 2,
};


const error_logs = {};


class LpError extends Error {
  constructor(type, code, message) {
    super();
    this.error_log_type = 0; // global
    this.code = code;
    this.message = message;
    this.type = type;
  }
}


class lpSpecialError extends LpError {
  constructor(type, code, message, component, id = -1) {
    super(type, code, message);
    this.error_log_type = 1; // local
    this.component_type = component;
    this.component_id = id;
  }
}

/**
 *
 * @param {LpError} error
 */
function pushErrorLog(error) {
  error_logs[Date.now()] = error;
}

function getErrors() {
  return error_logs;
}

window.errors_list = getErrors;
export function raiseError(component, code, message) {
  lpApp.logs.log(component, message);
  if (component === 'global') store.dispatch(lpSetError(new LpError(0, code, message)));
  else store.dispatch(lpSetError(new lpSpecialError(0, code, message, component)));
}
export function unraiseError(component) {
  store.dispatch(lpUnsetError(component));
}

window.raiseError = raiseError;
window.unraiseError = unraiseError;

export {
  lpErrorType,
  LpError,
  lpSpecialError,
};



// WEBPACK FOOTER //
// ./src/errors/error.js